gsap.config({ nullTargetWarn: false });
let coPdpSubHeroAni = document.querySelectorAll(".co-p-collage-subhero-ani");
gsap.set(coPdpSubHeroAni, { opacity: 0 });
gsap.to(coPdpSubHeroAni, {
  scrollTrigger: {
    trigger: ".co-p-collage-wrapper",
    start: "35% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
  },
  duration: 1,
  delay: 0.5,
  opacity: 1,
  ease: "power2.inOut",
  stagger: 0.25,
});
let coPdpSubHeroImgAni = document.querySelectorAll(
  ".co-p-collage-item-ani"
);
gsap.set(coPdpSubHeroImgAni, { scale: 0.75, yPercent: 25 });
gsap.set(coPdpSubHeroImgAni[0], { xPercent: 25 });
gsap.set(coPdpSubHeroImgAni[1], { xPercent: -25 });
// gsap.set(coPdpSubHeroImgAni[2], {yPercent: 0});
gsap.to(coPdpSubHeroImgAni, {
  scrollTrigger: {
    trigger: ".co-p-collage-wrapper",
    start: "25% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
  },
  duration: 1,
  scale: 1,
//   opacity: 1,
  xPercent: 0,
  yPercent: 0,
  ease: "power2.out",
  stagger: 0.05,
});
gsap.to(".co-p-collage-item-1-img", {
  scrollTrigger: {
    trigger: ".co-p-collage-wrapper",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  yPercent: 5,
  xPercent: -2.5,
});
gsap.to(".co-p-collage-item-2-img", {
  scrollTrigger: {
    trigger: ".co-p-collage-wrapper",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  yPercent: -5,
  xPercent: 2.5,
});
gsap.to(".co-p-collage-item-3-img", {
  scrollTrigger: {
    trigger: ".co-p-collage-wrapper",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  yPercent: -2.5,
  scale: 1.1,
});

// COMPARISON
(function() {
  const section = document.querySelector('.co-plp-s2');
  if (!section) return;

  function initSliders() {
    section.querySelectorAll('[data-comparison]').forEach(function(el) {
      const overlay = el.querySelector('.image-compare-overlay');
      const slider = el.querySelector('.image-compare-slider');
      const overlayImg = overlay.querySelector('img');
      let isResizing = false;
      let currentPct = 50;

      function updateDimensions() {
        var w = el.offsetWidth + 'px';
        if (overlayImg) overlayImg.style.width = w;
        var wrapper = overlay.firstElementChild;
        if (wrapper) wrapper.style.width = w;
      }

      function setPosition(pct) {
        currentPct = Math.max(0, Math.min(pct, 100));
        overlay.style.width = currentPct + '%';
        slider.style.left = currentPct + '%';
        el.setAttribute('aria-valuenow', Math.round(currentPct));
        el.setAttribute('aria-valuetext', Math.round(currentPct) + ' percent, showing ' + Math.round(currentPct) + '% before and ' + Math.round(100 - currentPct) + '% after');
      }

      function updateFromPointer(x) {
        const rect = el.getBoundingClientRect();
        const position = Math.max(0, Math.min(x - rect.left, rect.width));
        setPosition((position / rect.width) * 100);
      }

      function startResize(e) {
        e.preventDefault();
        isResizing = true;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        updateFromPointer(x);

        const move = function(e) {
          if (!isResizing) return;
          updateFromPointer(e.touches ? e.touches[0].clientX : e.clientX);
        };
        const end = function() {
          isResizing = false;
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', end);
          document.removeEventListener('touchmove', move);
          document.removeEventListener('touchend', end);
        };

        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', end);
        document.addEventListener('touchmove', move);
        document.addEventListener('touchend', end);
      }

      el.addEventListener('keydown', function(e) {
        var step = e.shiftKey ? 10 : 2;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            e.preventDefault();
            setPosition(currentPct - step);
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            e.preventDefault();
            setPosition(currentPct + step);
            break;
          case 'Home':
            e.preventDefault();
            setPosition(0);
            break;
          case 'End':
            e.preventDefault();
            setPosition(100);
            break;
        }
      });

      updateDimensions();
      el.addEventListener('mousedown', startResize);
      el.addEventListener('touchstart', startResize);
      window.addEventListener('resize', updateDimensions);
    });
  }

  function initTabs() {
    const buttons = Array.from(section.querySelectorAll('.co-plp-s2-tab-button'));
    const cells = section.querySelectorAll('.co-plp-s2-tabs-cell');
    const collectionButtons = section.querySelectorAll('.co-plp-s2-collection-button');

    function activateTab(index) {
      buttons.forEach(function(b) {
        b.classList.remove('co-active');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('tabindex', '-1');
      });
      buttons[index].classList.add('co-active');
      buttons[index].setAttribute('aria-selected', 'true');
      buttons[index].setAttribute('tabindex', '0');

      cells.forEach(function(c) { c.classList.remove('co-active'); });
      if (cells[index]) cells[index].classList.add('co-active');

      var text = buttons[index].getAttribute('data-button-text');
      var url = buttons[index].getAttribute('data-url');
      collectionButtons.forEach(function(a) {
        a.textContent = text;
        a.setAttribute('href', url);
      });
    }

    buttons.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        activateTab(i);
      });

      btn.addEventListener('keydown', function(e) {
        var target = i;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            target = i > 0 ? i - 1 : buttons.length - 1;
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            target = i < buttons.length - 1 ? i + 1 : 0;
            break;
          case 'Home':
            e.preventDefault();
            target = 0;
            break;
          case 'End':
            e.preventDefault();
            target = buttons.length - 1;
            break;
          default:
            return;
        }
        activateTab(target);
        buttons[target].focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initSliders(); initTabs(); });
  } else {
    initSliders();
    initTabs();
  }
})();
// COMPARISON
gsap.to(".co-plp-s2-drop-left", {
  scrollTrigger: {
    trigger: ".co-plp-s2",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  top: "-30%",
});
gsap.to(".co-plp-s2-drop-right", {
  scrollTrigger: {
    trigger: ".co-plp-s2",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  bottom: "-50%",
});